import AbstractFormulaNode from "./AbstractFormulaNode.js";

/**
 * `DataFormulaNode` is an abstract subclass representing data entered
 * manually by the user and saved in the database.
 *
 * @param {KeyFigure} keyFigure - The key figure having this
 *   node in its formula
 */
export default class DataFormulaNode extends AbstractFormulaNode {
	constructor({ keyFigure } = {}) {
		super(...arguments);

		// We need this because of Highcharts. Highcharts has a
		// merge() function which iterates over all properties of an
		// object passed as parameter, and all properties of each
		// property recursively. As there doesn't seem to be any
		// protection against cycles in merge(), this function
		// triggers a stack overflow. To avoid the stack overflow, we
		// hide the _year property (which typically introduces a
		// cycle) from Highcharts by making it non-enumerable.
		//
		// https://github.com/highcharts/highcharts/issues/6046
		Object.defineProperty(this, "_keyFigure", {
			enumerable: false,
			value: keyFigure,
			writable: true,
		});
	}

	getValueType() {
		return this._keyFigure.getValueType();
	}

	getName() {
		return this._keyFigure.getName();
	}

	accept(visitor, additionalInformation) {
		return visitor.visitDataNode(this, additionalInformation);
	}

	isLeaf() {
		return true;
	}

	static isKeyFigureDataNode() {
		return true;
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.keyFigure = context.mainKeyFigure;

		if (!data.keyFigure) {
			throw "No key figure found for key figure data node";
		}
	}
}
